import { useState } from 'react'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { IconButton } from '@/components/icon-button/IconButton'
import { MenuContent, MenuItemGroup } from '@/components/menu/MenuContent'
import { MenuItem } from '@/components/menu/MenuItem'
import { OverflowMenu, TrashDelete } from '@/assets/icons'

/**
 * Row-level overflow (kebab) menu for a Source Files row: a single destructive "Remove" item.
 */
export function SourceFileOverflowMenu({ onRemove, disabled = false }: { onRemove: () => void; disabled?: boolean }) {
  const [open, setOpen] = useState(false)
  return (
    <DropdownMenu.Root open={open} onOpenChange={setOpen}>
      <DropdownMenu.Trigger disabled={disabled} asChild>
        <IconButton icon={<OverflowMenu />} variant="plain" color="neutral" aria-label="File actions" disabled={disabled} />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <MenuContent align="end" alignOffset={-3} side="bottom" sideOffset={2} className="z-50 min-w-[150px]">
          <MenuItemGroup>
            <MenuItem
              label="Remove"
              icon={TrashDelete}
              variant="destructive"
              onSelect={() => {
                setOpen(false)
                onRemove()
              }}
            />
          </MenuItemGroup>
        </MenuContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
